import type { PrimaryFilterId } from '../../../filters/types/filters';
import type { ResolvedData } from '../../DataResolver/resolve-items';
import { useChart } from '../ChartProvider';
import { getIcicleSegment } from './icicle-segment';
import { TableIcicle } from './TableIcicle';
import { TaxonomyIcicle } from './TaxonomyIcicle';

export const IcicleChart = ({
  primaryDimension,
  data,
}: {
  primaryDimension: PrimaryFilterId;
  data?: ResolvedData;
}) => {
  const { item } = useChart();
  const segment = getIcicleSegment(
    primaryDimension,
    item?.plot?.secondaryDimension
  );
  return data ? (
    <TableIcicle
      data={data}
      segment={segment}
      primaryDimension={primaryDimension}
    />
  ) : (
    <TaxonomyIcicle segment={segment} primaryDimension={primaryDimension} />
  );
};
